// ** Redux Imports
import {createSlice} from '@reduxjs/toolkit'

// ** UseJWT import to get config
import useJwt from '@src/auth/jwt/useJwt'

const config = useJwt.jwtConfig

const initialUser = () => {
  const item = window.localStorage.getItem('userData')
  return item ? JSON.parse(item) : {}
}

export const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    userData: initialUser(),
    recoveryPassData: {username: '', token: ''},
    mfaRequired: localStorage.getItem('mfa_required') === 'true', // leer del localStorage
  },
  reducers: {
    handleLogin: (state, action) => {
      // console.log('LOGIN PAYLOAD:', action.payload)
      state.userData = action.payload
      state[config.storageTokenKeyName] = action.payload[config.storageTokenKeyName]
      state[config.storageRefreshTokenKeyName] = action.payload[config.storageRefreshTokenKeyName]

      // Guardar en localStorage
      localStorage.setItem('userData', JSON.stringify(action.payload))
      localStorage.setItem(config.storageTokenKeyName, JSON.stringify(action.payload.accessToken))
      localStorage.setItem(
        config.storageRefreshTokenKeyName,
        JSON.stringify(action.payload.refreshToken),
      )

      // ✅ Si viene el campo mfa_required, lo guardamos también
      if (typeof action.payload.mfa_required !== 'undefined') {
        state.mfaRequired = action.payload.mfa_required
        localStorage.setItem('mfa_required', action.payload.mfa_required.toString())
      } else {
        state.mfaRequired = false
        localStorage.removeItem('mfa_required')
      }
    },
    handleLogout: (state) => {
      state.userData = {}
      state[config.storageTokenKeyName] = null
      state[config.storageRefreshTokenKeyName] = null
      state.mfaRequired = false

      localStorage.removeItem('userData')
      localStorage.removeItem(config.storageTokenKeyName)
      localStorage.removeItem(config.storageRefreshTokenKeyName)
      localStorage.removeItem('mfa_required')
    },
    addRecoveryPassData: (state, action) => {
      state.recoveryPassData = Object.assign({}, state.recoveryPassData, action.payload)
    },
  },
})

export const {handleLogin, handleLogout, addRecoveryPassData} = authSlice.actions

export default authSlice.reducer
